import { createAPIRequest, createAPIResponse, ListResponse, ResponseWrapper } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';
import useSWR from 'swr';

export type PensionSchemeDTO = {
    id: number;
    pensionSchemeId: number;
    startDate: string;
};

const DEFAULT_PENSION_SCHEME = {
    id: 0,
    pensionSchemeId: 0,
    startDate: '2024-01-01',
};

export function useLatestPensionSchemeOrDefault() {
    const { data, error, isLoading, mutate } = useSWR<ListResponse<PensionSchemeDTO>>(getSalaryPensionSchemeURL());

    let valuesToReturn: undefined | PensionSchemeDTO[];
    if (isLoading) {
        valuesToReturn = undefined;
    } else {
        valuesToReturn = data?.values && data.values.length > 0 ? data.values : [DEFAULT_PENSION_SCHEME];
    }

    return {
        data: valuesToReturn?.[valuesToReturn?.length - 1],
        error,
        isLoading,
        mutate,
    };
}

function getSalaryPensionSchemeURL({ id }: { id?: number } = {}) {
    const defaultFields = ['id', 'startDate', 'pensionSchemeId'];
    const params = new URLSearchParams();
    params.set('fields', [...defaultFields].sort().join(','));

    return `${APIUrls.SALARY_SETTINGS_PENSION}/${id ?? ''}?${params.toString()}`;
}

export async function createPensionScheme(dto: Partial<PensionSchemeDTO>) {
    const request = createAPIRequest(getSalaryPensionSchemeURL(), {
        method: 'POST',
        body: JSON.stringify(dto),
        headers: {
            'content-type': 'application/json; charset=utf-8',
        },
    });
    const response = await window.fetch(request);
    return await createAPIResponse<ResponseWrapper<PensionSchemeDTO>>(request, response);
}

export async function updatePensionScheme(id: number, dto: Partial<PensionSchemeDTO>) {
    const request = createAPIRequest(getSalaryPensionSchemeURL({ id }), {
        method: 'PUT',
        body: JSON.stringify(dto),
        headers: {
            'content-type': 'application/json; charset=utf-8',
        },
    });
    const response = await window.fetch(request);
    return await createAPIResponse<ResponseWrapper<PensionSchemeDTO>>(request, response);
}
